<script>
import pageMixin from '@src/mixins/pagination'
import { genderFilter } from '@utils/filter-value-to-text'
import formatDate from '@utils/format-date'
import lazyLoadComponent from '@router/lazyload-component'
import BaseButtonDialog from '@components/BaseButtonDialog'
import { memberComputed, authComputed } from '@state/helpers'
import { debounce } from 'lodash'
import formatCurrency from '@utils/format-currency'
import request from '@utils/request'
import changePageMixin from '@src/mixins/changePage'
const conditionList = (list) => {
  return list.filter(({ condition }) => {
    if (condition) return condition()
    return true
  })
}
export default {
  page: {
    title: '會員管理',
    meta: [{ name: 'description', content: 'Member List' }],
  },
  components: {
    BaseButtonDialog,
    NotificationWrite: () => lazyLoadComponent(import('@components/NotificationWrite')),
    TagPopover: () => lazyLoadComponent(import('./components/TagPopover')),
  },
  filters: {
    genderFilter,
    formatDate,
  },
  mixins: [pageMixin, changePageMixin],
  data() {
    return {
      loadedData: [],
      dialogVisible: false,
      selectedMember: [],
      filterData: {
        tagIds: [],
        search: '',
        memberLevelIds: '',
        block: '',
        lineNotifyStatus: '',
        gender: '',
        birthdayMonth: '',
        monthsWithoutOrder: '',
      },
      tagList: [],
      memberLevelList: [],
      tryingFetchTag: false,
      isLoading: false,
      columnShowList: ['會員等級', '隸屬標籤', '黑名單', '有效訂單數', '累積消費金額', '點數餘額'],
      pageSize: 10,
      fileListArr: [], // 檔案清單
      businessEmail: '', // 業務的email
      handleSelected: new Map(), // 所有被選到的清單
      apiSliceNumber: 5, // 多少個資料打一次api
      sendType: '', // 選取發送 or 全部發送
      totalMember: 0, // 總共有多少個會員
    }
  },
  watch: {
    currentPage: {
      async handler(nvl, ovl) {
        if (!this.selectedMember) {
          return // 如果 selectedMember 是 undefined，则提前返回
        }
        await this.changePage(ovl, this.selectedMember, () => this.tryToSearch())
      },
      immediate: true,
    },
    pageSize: {
      handler() {
        this.tryToSearch()
      },
    },
  },
  async created() {
    try {
      await this.createdToDo()
    } catch (error) {
      console.error(error.message)
    }
  },
  computed: {
    ...memberComputed,
    ...authComputed,
    remarkOptions() {
      return conditionList([
        {
          label: '會員等級',
          condition: () => {
            return this.currentUserRoutes.includes('view-memberlevel')
          },
        },
        {
          label: '隸屬標籤',
        },
        {
          label: '黑名單',
        },
        {
          label: '有效訂單數',
        },
        {
          label: '累積消費金額',
        },
        {
          label: '點數餘額',
        },
        {
          label: '最後訂單日期',
        },
      ])
    },
    onePageDisabledSendBtn() {
      return this.selectedMember.length === 0
    },
    memberIds() {
      return this.selectedMember.map((member) => member.id)
    },
    /**
     * @descrption 如果有group就判斷是否有6 -> 超級管理者
     */
    memberGroup() {
      if (this.$store.state?.auth?.currentUser?.groups) {
        return this.$store.state.auth.currentUser.groups.includes(6)
      } else {
        return false
      }
    },
    /**
     * @description 商家的alias
     */
    storeAlias() {
      if (this.$store.state?.merchant?.cached?.alias) {
        return this.$store.state?.merchant?.cached?.alias
      } else {
        return ''
      }
    },
    messageData() {
      const phone = this.$store.state.merchant.cached.phoneNumber

      return {
        姓名: '客戶姓名',
        店家名稱: this.currentUser.merchantName,
        店家電話: phone,
      }
    },
  },
  methods: {
    /**
     * @description 在圖片上傳之前
     */
    beforeImageUpload(file) {
      try {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
        if (this.businessEmail.length === 0 || !emailRegex.test(this.businessEmail)) {
          this.$message({ message: '請輸入正確e-mail', type: 'error' })
          return false
        }
        if (file.type === 'application/vnd.ms-excel' || file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          return true
        } else {
          this.$message({ message: '請上傳正確檔案', type: 'error' })
          return false
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 超過上限文件要幹嘛
     */
    handleExceed() {
      this.$message({ message: '僅能上傳一個檔案', type: 'error' })
    },
    /**
     * @description 觸發提交上傳
     */
    async submitUpload(params) {
      try {
        const formData = new FormData()
        formData.append('file', params.file)
        formData.append('merchantAlias', this.storeAlias)
        formData.append('mode', 'validate')
        formData.append('email', this.businessEmail)
        const url = '/admin/merchant/member/import'
        const response = await request.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        if (response.code === 200) {
          this.$message({ message: '已送出驗證', type: 'success' })
          this.$refs.upload.clearFiles()
        }
      } catch (error) {
        console.error(error.message)
      }
    },
    formatCurrency,
    /**
     * @description vue 生命週期 created要做的事情
     */
    async createdToDo() {
      const page = this.$route.params.pagination
      if (page) {
        this.currentPage = page
      }
      this.tryToFetchMemberList()
    },
    async tryToSearchFilter() {
      // 當篩選前不在第一頁的時候，跳回第一頁
      this.isLoading = true
      if (this.currentPage !== 1) {
        this.currentPage = 1
      } else {
        await this.tryToSearch()
      }
      this.isLoading = false
    },
    async tryToSearch(data) {
      let query = {
        ...this.$route.query,
        ...this.pageQuery,
        ...this.filterData,
        limit: this.pageSize,
        lineNotify: this.lineNotifyStatus,
        memberLevelIds: this.filterData.memberLevelIds ? [this.filterData.memberLevelIds] : [],
      }

      if (data) {
        query = {
          ...query,
          ...data,
        }
        this.filterData = data
        query.memberLevelIds = query.memberLevelIds ? [query.memberLevelIds] : []
      }

      const { items, total } = await this.$store.dispatch('member/fetchList', query)
      this.loadedData = items
      this.totalMember = total
      this.$nextTick(() => {
        this.$refs.pagination && this.$refs.pagination.updateTotal(total)
      })
      this.reductionSelected(this.currentPage, this.loadedData, this.$refs.multipleTable)
    },
    async tryToFetchMemberList() {
      // if (!this.currentUserRoutes.includes('view-memberlevel')) return
      const { items } = await this.$store.dispatch('memberLevel/fetchList', { paginate: 0 })
      this.memberLevelList = items
    },
    goToMemberDetail(row) {
      const { id: memberId } = row
      this.$router.push({
        name: 'view-member',
        params: {
          memberId,
          pagination: this.currentPage,
        },
      })
    },
    handleSelectionChange(value) {
      this.selectedMember = value
    },
    closeDialog() {
      this.dialogVisible = false
    },
    async tryToFetchTag() {
      this.tryingFetchTag = true
      this.tagList = await this.$store.dispatch('member/fetchTags', {
        search: '',
      })
      this.tryingFetchTag = false
    },
    async changeColumnShowList(value) {
      await this.setColumnShowList(value)
    },
    async setColumnShowList(value) {
      this.columnShowList = value
    },
    isField(type) {
      return this.columnShowList.includes(type)
    },
    dialogSend(sendType) {
      try {
        this.handleSelected.set(this.currentPage, this.selectedMember)
        const mergedArrayList = this.mergedArray()
        if (mergedArrayList.length === 0 && sendType === 'part') {
          this.$message({ message: '請選擇發送對象', type: 'error' })
          return
        }
        this.sendType = sendType
        this.dialogVisible = true
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 重新reload視窗
     */
    async reload() {
      this.currentPage = 1 // 現在的分頁
      this.selectedMember = []
      this.handleSelected = new Map() // 目前各分頁選到的列
      await this.tryToSearch()
    },
    tryToSearchByInput: debounce(function() {
      this.tryToSearchFilter()
    }, 800),
    async openMemberFilterWindow() {
      await this.tryToFetchTag()

      const memberFilterData = {
        memberLevelList: this.memberLevelList,
        tagList: this.tagList,
      }
      this.$emit('openMemberFilterWindow', memberFilterData)
    },
  },
}
</script>

<template>
  <div :class="$style.pageContent">
    <div :class="$style.btnTop" class="btn-top-box">
      <div class="d-flex flex-md-row flex-column">
        <div class="w-75">
          <el-input v-model.trim.lazy="filterData.search" class="isStyleSearch mb-md-0 mb-3" clearable placeholder="請輸入客戶姓名或是手機號碼" @input="tryToSearchByInput">
            <!-- <BaseIcon slot="suffix" name="search" class="el-input__icon" /> -->
          </el-input>
        </div>
        <div class="buttonGroup w-25">
          <div style="margin-left: 10px;">
            <el-button size="small" type="primary" class="is-round w-100">搜尋</el-button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="memberGroup" class="businessUse">
      <el-input v-model="businessEmail" placeholder="請填寫e-mail取得驗證結果" class="w-75"></el-input>
      <div class="w-25">
        <el-upload
          ref="upload"
          action="/upload-excel"
          class="uploadFix"
          list-type="text"
          :auto-upload="true"
          :before-upload="beforeImageUpload"
          :http-request="submitUpload"
          :file-list="fileListArr"
          :limit="1"
          :on-exceed="handleExceed"
        >
          <div class="buttonGroup">
            <el-button slot="trigger" style="margin-left: 10px;" size="small" type="primary" class="is-round">選取文件並上傳驗證</el-button>
          </div>
        </el-upload>
      </div>
    </div>
    <div :class="$style.btnTop" class="btn-top-box">
      <!-- <div class="d-flex flex-md-row flex-column">
        <span class="mb-md-0 mb-3 ml-lg-3">
          <el-button class="is-round h-100" @click="dialogSend('all')">
            <BaseIcon name="mail-bulk" />
            <span>全部通知</span>
          </el-button>
        </span>
        <span class="mb-md-0 mb-3 ml-lg-3">
          <el-button class="is-round h-100" @click="dialogSend('part')">
            <BaseIcon name="mail-bulk" />
            <span>選取通知</span>
          </el-button>
        </span>
        <TagPopover :selected-member="selectedMember" class="mb-md-0 mb-3 ml-lg-3" @update="tryToSearch" />
        <el-popover placement="bottom-end" width="250" trigger="click" popper-class="isStyleField" class="ml-lg-3">
          <div class="mb-3">欄位顯示：</div>
          <el-checkbox-group v-model="columnShowList">
            <el-checkbox v-for="item in remarkOptions" :key="item.value" :label="item.label"> </el-checkbox>
          </el-checkbox-group>
          <el-button slot="reference" class="isStyleField is-round">
            <BaseIcon name="calendar-edit" />
            欄位顯示
            <BaseIcon name="angle-down" />
          </el-button>
        </el-popover>
      </div> -->
      <el-row :gutter="20">
        <el-col :span="6">
          <el-button class="is-round h-100 w-100" @click="dialogSend('all')">
            <BaseIcon name="mail-bulk" />
            <span>全部通知</span>
          </el-button>
        </el-col>
        <el-col :span="6">
          <el-button class="is-round h-100 w-100" @click="dialogSend('part')">
            <BaseIcon name="mail-bulk" />
            <span>選取通知</span>
          </el-button>
        </el-col>
        <el-col :span="6">
          <TagPopover :selected-member="selectedMember" @update="tryToSearch" />
        </el-col>
        <el-col :span="6">
          <el-popover placement="bottom-end" width="250" trigger="click" popper-class="isStyleField">
            <div class="mb-3">欄位顯示：</div>
            <el-checkbox-group v-model="columnShowList">
              <el-checkbox v-for="item in remarkOptions" :key="item.value" :label="item.label"> </el-checkbox>
            </el-checkbox-group>
            <el-button slot="reference" class="isStyleField is-round w-100">
              <BaseIcon name="calendar-edit" />
              欄位顯示
              <BaseIcon name="angle-down" />
            </el-button>
          </el-popover>
        </el-col>
      </el-row>
    </div>
    <!-- <BaseTableSearch v-slot="{ fields }" hide-action :default-value.sync="filterData" @reset="tryToSearch" @tryToFetchList="tryToSearchFilter">
      <el-form-item prop="tagIds">
        <el-select v-model="fields.tagIds" value-key="id" multiple placeholder="過濾標籤" :loading="tryingFetchTag" :loading-text="'取得資料中...'" @change="tryToSearchFilter" @focus="tryToFetchTag">
          <el-option v-for="(tag, index) in tagList" :key="`list-tag-${index}`" :label="tag.title" :value="tag.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="ml-md-2" prop="memberLevelIds">
        <el-select v-model="fields.memberLevelIds" value-key="id" placeholder="選擇會員等級" clearable @change="tryToSearchFilter">
          <el-option v-for="(item, index) in memberLevelList" :key="`list-tag-${index}`" :label="item.title" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="ml-md-2" prop="block">
        <el-select v-model="fields.block" value-key="id" placeholder="選擇黑名單" clearable @change="tryToSearchFilter">
          <el-option :key="`list-tag-y`" label="是" value="1"></el-option>
          <el-option :key="`list-tag-n`" label="否" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="ml-md-2">
        <el-select ref="lineNotifySelect" v-model="fields.lineNotifyStatus" value-key="id" placeholder="LineNotify綁定狀態" clearable @change="tryToSearchFilter">
          <el-option :key="`list-tag-y`" label="是" value="1"></el-option>
          <el-option :key="`list-tag-n`" label="否" value="0"></el-option>
        </el-select>
      </el-form-item>
    </BaseTableSearch> -->
    <div class="isStylePageContent pt-0">
      <div class="w-100 pt-3 mb-3">
        <el-button class="is-round w-100" @click="openMemberFilterWindow">篩選會員</el-button>
      </div>
      <div class="el-table-wrapper">
        <el-table ref="multipleTable" v-loading="isLoading" :data="loadedData" :class="$style['member-table']" @row-click.once="goToMemberDetail" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="80"> </el-table-column>
          <el-table-column v-slot="{ row }" label="姓名電話" min-width="150">
            <b>{{ row.fullName }} {{ row.gender | genderFilter }}</b>
            <div style="font-size: 12px">{{ `${row.phoneCode} ${row.phoneNumber}` }}</div>
          </el-table-column>
          <template v-if="$hasMemberLevel()">
            <el-table-column v-if="isField('會員等級') || isField('隸屬標籤')" v-slot="{ row }" label="會員等級/隸屬標籤" min-width="180">
              <div v-if="isField('會員等級')">{{ row.level.title }}</div>
              <div v-if="isField('隸屬標籤')">
                <el-tag v-for="tag in row.tags" :key="`tag-${tag.id}`" class="isStyleTag" disable-transitions>
                  {{ tag.title }}
                </el-tag>
              </div>
            </el-table-column>
          </template>
          <template v-else>
            <el-table-column v-if="isField('隸屬標籤')" v-slot="{ row }" label="隸屬標籤" min-width="180">
              <div v-if="isField('隸屬標籤')">
                <el-tag v-for="tag in row.tags" :key="`tag-${tag.id}`" class="isStyleTag" disable-transitions>
                  {{ tag.title }}
                </el-tag>
              </div>
            </el-table-column>
          </template>
          <el-table-column v-if="isField('黑名單')" v-slot="{ row }" label="黑名單" min-width="70">
            <div>{{ row.block.isBlock ? '是' : '否' }}</div>
          </el-table-column>
          <el-table-column v-if="isField('有效訂單數')" label="有效訂單數" prop="ordersCounts" min-width="105"></el-table-column>
          <el-table-column v-if="isField('累積消費金額')" v-slot="{ row }" label="累積消費金額" prop="ordersTotal" min-width="110">
            <span style="font-family: 'Jost';">{{ `$${formatCurrency(row.ordersTotal)}` }}</span>
          </el-table-column>
          <el-table-column v-if="isField('點數餘額') && $hasDeposit()" v-slot="{ row }" label="點數餘額" prop="reduce" min-width="100">
            <span style="font-family: 'Jost';">{{ `$${formatCurrency(row.reduce)}` }}</span>
          </el-table-column>
          <el-table-column v-if="isField('最後訂單日期')" v-slot="{ row }" label="最後訂單日期" min-width="115">
            <div class="Jost" style="font-weight: 500">{{ row.lastOrderDate | formatDate }}</div>
            <span>{{ row.lastOrderDate | formatDate('HH:mm') }}</span>
          </el-table-column>
          <el-table-column min-width="40">
            <el-tooltip content="查看客戶詳細資料" placement="top">
              <el-button type="text">
                <BaseIcon name="ellipsis-v" />
              </el-button>
            </el-tooltip>
          </el-table-column>
        </el-table>
      </div>
      <BasePagination ref="pagination" :current-page.sync="currentPage" :page-size.sync="pageSize" show-size />
    </div>

    <BaseButtonDialog :only-dialog="true" :title="'撰寫通知'" :dialog-visible.sync="dialogVisible" :destroy="true" floating>
      <NotificationWrite
        v-if="dialogVisible"
        :source-name="'memberList'"
        :selected-member-ids="memberIds"
        :map-template-string="messageData"
        :handle-selected="Object.fromEntries(handleSelected)"
        :total-member="totalMember"
        :filter-data="filterData"
        :send-type="sendType"
        from="/member"
        @close="closeDialog"
        @reload="reload"
      />
    </BaseButtonDialog>
  </div>
</template>
<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

.member-table {
}

.pageContent {
  position: relative;

  :global {
    .businessUse {
      display: flex;
      width: 100%;
      margin-bottom: 10px;

      :global {
        .el-input {
          width: 100%;
        }
      }
    }

    .uploadFix {
      width: 100%;

      :global {
        .el-upload {
          line-height: 0;
          width: 100%;
          height: auto;
        }

        .buttonGroup {
          display: flex;

          :global {
            .el-button {
              width: 100%;
            }
          }
        }
      }
    }
  }
}

.warning {
  background-color: #bf7e45 !important;
  color: white !important;
  margin-top: -20px;
  margin-bottom: 20px;
  padding: 18px 16px;

  :global {
    .el-alert__closebtn {
      color: white !important;
      top: 18px;
      font-size: 18px;
    }
  }
}

.fieldStyle {
  position: relative;
  width: 150px;
  max-width: 100%;

  :global {
    .showText {
      color: $color-secondary;
      position: absolute;
      z-index: 2;
      width: 80%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: start;
      padding-left: 33px;

      svg {
        margin-right: 10px;
      }
    }

    .el-select {
      height: 44px;
    }

    .el-select__tags {
      display: none;
      height: 44px;
    }
  }
}

.btnTop {
  padding: 0.5rem 0;
  margin-bottom: 10px;
}
</style>
